import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { DateFieldModule } from '../date-selector'
import { PullEligibilityDialogComponent } from './pull-eligibility-dialog.component'

const dialogs = []

@NgModule({
  declarations: [
    PullEligibilityDialogComponent,
    ...dialogs,
  ],
  imports: [
    CommonModule,
    DateFieldModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [PullEligibilityDialogComponent],
})
export class PullEligibilityDialogModule {}
